import React from 'react';

import { useIsMobile } from '../../../../../hooks/useIsMobile';
import { useStudentSelector } from '../../../../../store/selectors/useStudentSelector';
import { isSequencedFlowStep, Item, ModalSize } from '@ael/core-api';

export const useContentDisplayed = (item: Item) => {
  const displayed = useStudentSelector((state) => state.currentSequencedFlowPosition.displayed);
  const isMobile = useIsMobile();

  const contentDisplayed = React.useMemo(() => {
    if (isSequencedFlowStep(item)) {
      if (!isMobile && item.modalSize === ModalSize.Small) {
        return true;
      }
      if (item.position) {
        return displayed;
      }
    }
    return true;
  }, [displayed, isMobile, item]);

  return { contentDisplayed };
};
